import React, { useEffect, useState } from "react"
import ProgressBar from "../../../../Components/ProgressBar/ProgressBar"
import Direction from "../../Types/Direction"
import "./MainLayout.css"

interface Props
{
	percentage?: number
	canGoNext: boolean
	canGoPrevious: boolean
	onNavigate: (direction: Direction) => void
	children: React.ReactNode
}

const MainLayout = (props: Props) =>
{
	const [node, setNode] = useState<HTMLElement | null>(null);
	const [canScroll, setScrollable] = useState(false);

	const isScrollable = (element: HTMLElement | null): boolean =>
	{
		const hasScrollableContent = element ? (element!.scrollHeight > element!.clientHeight) : false;

		const overflowYStyle = element ? window.getComputedStyle(element).overflowY : null;
		const isOverflowHidden = overflowYStyle ? overflowYStyle.indexOf('hidden') !== -1 : false;

		return hasScrollableContent && !isOverflowHidden;
	}

	// eslint-disable-next-line
	useEffect(() =>
	{
		setScrollable(isScrollable(node))
	})

	return (
		<div className="main-layout-container">
			<div className="main-layout-logo-container">
				<img src="../assets/logo.png" alt="" className="main-layout-logo" />
			</div>
			<div ref={n => setNode(n)} className={`main-layout-content ${canScroll ? "main-layout-shadow" : ""}`}>
				{props.children}
			</div>
			<div className="main-layout-footer" style={{ visibility: props.percentage === undefined ? "collapse" : "inherit" }}>
				<ProgressBar canGoNext={props.canGoNext} canGoPrevious={props.canGoPrevious} percentage={props.percentage ?? 0} onNextClick={() => props.onNavigate(Direction.next)} onPreviousClick={() => props.onNavigate(Direction.previous)} />
			</div>
		</div>
	)
}

export default MainLayout
